import { type Table } from 'dexie'

export interface Translation {
  id?: number
  word: string
  definition: string
  type: string
}

export interface TranslationTable {
  translation: Table<Translation>
}

export const translationSchema = {
  translation: '++id, word, definition, type'
}
